export default {
  // General
  affiliateProgram: "برنامج شركاء الإحالة",
  becomeAffiliate: "كن شريك إحالة",
  affiliateDashboard: "لوحة تحكم الشريك",
  referralPartner: "شريك إحالة",
  referralPartners: "شركاء الإحالة",

  // Signup
  affiliateSignupTitle: "انضم لبرنامج شركاء الإحالة",
  affiliateSignupDesc: "سهّل حجوزات حملات DOOH لعملائك واكسب عمولات على كل صفقة",
  applicantName: "الاسم الكامل",
  companyNameOptional: "اسم الشركة / الوكالة (اختياري)",
  applicantType: "نوع المتقدم",
  individual: "فرد",
  agency: "وكالة",
  salesExperience: "خبرة في المبيعات / التسويق",
  whyAffiliate: "لماذا تريد أن تكون شريك إحالة؟",
  websiteUrl: "رابط الموقع / المحفظة",
  applicationPending: "الطلب قيد المراجعة",
  applicationPendingDesc: "طلب الشراكة الخاص بك قيد المراجعة. سنبلغك بمجرد معالجته.",
  applicationApproved: "تمت الموافقة على الطلب",
  applicationApprovedDesc: "تهانينا! أنت شريك إحالة معتمد.",
  applicationRejected: "تم رفض الطلب",
  applicationRejectedDesc: "للأسف تم رفض طلبك.",
  rejectionReason: "سبب الرفض",
  submitApplication: "إرسال الطلب",
  applicationSubmitted: "تم إرسال الطلب!",
  applicationSubmittedDesc: "طلب الشراكة قيد المراجعة. سنبلغك قريباً.",
  alreadyApplied: "لقد تقدمت بالفعل",

  // Dashboard Tabs
  overview: "نظرة عامة",
  createCampaign: "إنشاء حملة",
  myBookings: "حجوزاتي",
  commissions: "العمولات",
  clients: "العملاء",
  profile: "الملف الشخصي",
  support: "الدعم",

  // Dashboard - Overview
  totalSales: "إجمالي المبيعات",
  totalCommission: "إجمالي العمولات",
  pendingCommission: "العمولات المعلقة",
  activeClients: "العملاء النشطون",
  totalBookings: "إجمالي الحجوزات",
  manageReferrals: "إدارة الإحالات والعمولات",

  // Dashboard - Bookings
  referrals: "الإحالات",
  noReferrals: "لا توجد إحالات بعد",
  noReferralsDesc: "شارك رابط الإحالة الخاص بك لبدء كسب العمولات",
  noBookings: "لا توجد حجوزات بعد",
  noBookingsDesc: "أنشئ حملة نيابة عن عميل للبدء",
  saleAmount: "مبلغ البيع",
  commission: "العمولة",
  status: "الحالة",
  pending: "معلق",
  confirmed: "مؤكد",
  paid: "مدفوع",
  viewInvoice: "عرض الفاتورة",
  viewPO: "عرض أمر الشراء",
  campaignName: "الحملة",
  client: "العميل",
  budget: "الميزانية",
  dates: "التواريخ",

  // Dashboard - Clients
  noClients: "لا يوجد عملاء بعد",
  noClientsDesc: "يتم إضافة العملاء تلقائياً عند إنشاء حملات نيابة عنهم",
  clientName: "اسم العميل",
  clientEmail: "البريد الإلكتروني",
  clientCompany: "الشركة",
  clientPhone: "الهاتف",
  totalSpend: "إجمالي الإنفاق",
  campaignsCount: "الحملات",
  addClient: "إضافة عميل",
  editClient: "تعديل العميل",
  deleteClient: "حذف العميل",
  clientNotes: "ملاحظات",

  // Campaign Creation
  clientInformation: "معلومات العميل",
  clientInfoDesc: "أدخل بيانات العميل لحجز هذه الحملة",
  onBehalfOf: "الحجز نيابة عن العميل",

  // Admin
  affiliateApplications: "شركاء الإحالة",
  approveAffiliate: "موافقة",
  rejectAffiliate: "رفض",
  rejectAffiliateTitle: "رفض الشريك",
  rejectAffiliateConfirm: "هل أنت متأكد من رفض هذا الطلب؟",
  confirmRejection: "تأكيد الرفض",
  affiliateApproved: "تمت الموافقة على الشريك",
  affiliateApprovedDesc: "تمت الموافقة عليه كشريك إحالة",
  affiliateRejected: "تم رفض الشريك",
  affiliateRejectedDesc: "تم رفضه",
  noApplications: "لا توجد طلبات في هذه الفئة",

  // Program Page
  programHeroTitle: "اكسب من تسهيل حجوزات حملات DOOH",
  programHeroDesc: "انضم لبرنامج شركاء الإحالة واكسب عمولات عبر جلب المعلنين لحجز الحملات. أنت تدير علاقة العميل — نحن نتولى الباقي.",
  roleTitle: "دور شريك الإحالة",
  roleDesc: "بصفتك شريك إحالة، تقوم بتحديد المعلنين المحتملين والتواصل معهم، وعرض خيارات الحملات، وتسهيل عملية الحجز بالكامل نيابة عن عملائك.",
  bookingFlowTitle: "كيف تعمل عملية الحجز",
  whatPartnersDoTitle: "ما يفعله الشركاء",
  whatPartnersDontDoTitle: "ما لا يفعله الشركاء",
  platformHandlesTitle: "ما تتولاه المنصة",
} as const;
